module.exports = __webpack_public_path__ + "img/jianjie (1).f555c4ed.png";